<script lang="ts">
  import { session } from '../../lib/auth.svelte';
  import { isPilotMode } from '../../lib/pilot';
  import { tenantCtx } from '../../lib/tenant.svelte';
  import { clinicPreview, isDemoTenant } from '../../lib/clinic-preview.svelte';
  import { dashboardPreview } from '../../lib/dashboard/preview.svelte';
  import { resolveDashboardRole, DASHBOARD_TITLES, type DashboardRole } from '../../lib/dashboard/resolve';
  import DashboardRolePicker from './DashboardRolePicker.svelte';
  import ClinicPreviewBar from './ClinicPreviewBar.svelte';
  import ClinicDashboard from './clinic/ClinicDashboard.svelte';
  import AdminDashboard from './roles/AdminDashboard.svelte';
  import EnfermeriaDashboard from './roles/EnfermeriaDashboard.svelte';
  import MedicoDashboard from './roles/MedicoDashboard.svelte';
  import RecepcionDashboard from './roles/RecepcionDashboard.svelte';
  import LaboratorioDashboard from './roles/LaboratorioDashboard.svelte';
  import CajaDashboard from './roles/CajaDashboard.svelte';
  import FarmaciaDashboard from './roles/FarmaciaDashboard.svelte';
  import ImagenologiaDashboard from './roles/ImagenologiaDashboard.svelte';
  import QuirofanoDashboard from './roles/QuirofanoDashboard.svelte';
  import FinanzasDashboard from './roles/FinanzasDashboard.svelte';
  import MspasDashboard from './roles/MspasDashboard.svelte';
  import AuditoriaDashboard from './roles/AuditoriaDashboard.svelte';

  let { onNavigate }: { onNavigate: (tab: string) => void } = $props();

  /** Rol efectivo: preview manual (demo) o rol del usuario. */
  const rol = $derived(
    dashboardPreview.role ?? resolveDashboardRole(session.value?.roles),
  );

  const useClinicDashboard = $derived(
    clinicPreview.org != null || tenantCtx.isClinicEdition,
  );

  const showRolePicker = $derived(
    !useClinicDashboard
    && (isPilotMode()
    || isDemoTenant(session.value?.tenantId)
    || (session.value?.roles ?? []).some(r => r === 'admin-tenant' || r === 'admin-platform')),
  );
</script>

<ClinicPreviewBar />

{#if useClinicDashboard}
  <ClinicDashboard {onNavigate} />
{:else}
  {#if showRolePicker}
    <DashboardRolePicker />
  {/if}

  <div class="active-dash" data-role={rol}>
  <p class="active-label">
    Vista operativa · <strong>{DASHBOARD_TITLES[rol]}</strong>
  </p>

  {#key rol}
    {#if rol === 'admin'}
      <AdminDashboard {onNavigate} />
    {:else if rol === 'enfermeria'}
      <EnfermeriaDashboard {onNavigate} />
    {:else if rol === 'medico'}
      <MedicoDashboard {onNavigate} />
    {:else if rol === 'recepcion'}
      <RecepcionDashboard {onNavigate} />
    {:else if rol === 'laboratorio'}
      <LaboratorioDashboard {onNavigate} />
    {:else if rol === 'caja'}
      <CajaDashboard {onNavigate} />
    {:else if rol === 'farmacia'}
      <FarmaciaDashboard {onNavigate} />
    {:else if rol === 'imagenologia'}
      <ImagenologiaDashboard {onNavigate} />
    {:else if rol === 'quirofano'}
      <QuirofanoDashboard {onNavigate} />
    {:else if rol === 'finanzas'}
      <FinanzasDashboard {onNavigate} />
    {:else if rol === 'mspas'}
      <MspasDashboard {onNavigate} />
    {:else if rol === 'auditoria'}
      <AuditoriaDashboard {onNavigate} />
    {:else}
      <AdminDashboard {onNavigate} />
    {/if}
  {/key}
  </div>
{/if}

<style>
  .active-label {
    margin: 0 0 0.75rem;
    font-size: 0.78rem;
    color: var(--text-secondary);
    padding: 0.45rem 0.75rem;
    background: var(--glass-bg-card);
    backdrop-filter: var(--glass-blur-light);
    -webkit-backdrop-filter: var(--glass-blur-light);
    border: 1px solid var(--glass-border);
    border-radius: var(--radius-lg);
    display: inline-block;
  }
  .active-label strong { color: var(--brand-deep); font-size: 0.9rem; }
  .active-dash { animation: fadeIn 0.3s cubic-bezier(0.34, 1.56, 0.64, 1); }
  @keyframes fadeIn {
    from { opacity: 0.3; transform: translateY(10px) scale(0.98); }
    to { opacity: 1; transform: none; }
  }
</style>
